export default __webpack_public_path__ + "static/Harvester3-a9b91787acedba75656cc11a77daa2c8.jpg";